import { useState } from 'react'
import StoryEngine from './components/StoryEngine'
import AICreator from './components/AICreator'
import Onboarding from './components/Onboarding'
import StoryLibrary from './components/StoryLibrary'
import { useStory } from './contexts/StoryContext'

function App() {
  const { userSettings, currentStory, setUserSettings } = useStory()
  const [view, setView] = useState('onboarding') // onboarding | library | story | creator

  // If no settings yet, show onboarding
  if (!userSettings.ageGroup && view !== 'onboarding') {
    setView('onboarding')
  }

  const handleResetOnboarding = () => {
    // Clear user settings and go back to onboarding
    setUserSettings({
      culture: null,
      ageGroup: null,
      learnerMode: false,
      nativeLanguage: null,
      targetLanguage: null
    })
    setView('onboarding')
  }

  return (
    <div className="app">
      {view === 'onboarding' && (
        <Onboarding onComplete={() => setView('library')} />
      )}
      
      {view === 'library' && (
        <StoryLibrary 
          onSelectStory={() => setView('story')}
          onCreateStory={() => setView('creator')}
          onResetOnboarding={handleResetOnboarding}
        />
      )}
      
      {view === 'story' && currentStory && (
        <StoryEngine onExit={() => setView('library')} />
      )}
      
      {view === 'creator' && (
        <AICreator 
          onBack={() => setView('library')}
          onStoryGenerated={() => setView('story')}
        />
      )}
    </div>
  )
}

export default App
